<div class="flex flex-col justify-center items-center space-y-20">
  <img class="w-[200px]" [src]="this.resource.header.logo_h" />
  <div class="space-y-7">
    <p class="text-center">
      Le parcours de souscription auquel vous essayer d'accéder est indisponible
    </p>
    <p class="titleError text-center text-2xl">ERROR 404</p>
  </div>
</div>

